import { render, staticRenderFns } from "./BaseItem.vue?vue&type=template&id=5ad7453b&scoped=true"
import script from "./BaseItem.vue?vue&type=script&lang=js"
export * from "./BaseItem.vue?vue&type=script&lang=js"
import style0 from "./BaseItem.vue?vue&type=style&index=0&id=5ad7453b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad7453b",
  null
  
)

/* custom blocks */
import block0 from "./BaseItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports